var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"progress",staticClass:"playback-wrapper",on:{"click":_vm.clickProgress}},[_c('a-progress',{staticClass:"custom-progress",attrs:{"percent":_vm.curPercent,"strokeWidth":5,"showInfo":false,"strokeColor":"#1890ff"}}),_c('div',{staticClass:"custom-progress-dot",style:({ left: `${_vm.curPercent}%` })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }